import { render } from "./moreHistory.vue?vue&type=template&id=08044d9a"
import script from "./moreHistory.vue?vue&type=script&lang=js"
export * from "./moreHistory.vue?vue&type=script&lang=js"

import "./moreHistory.vue?vue&type=style&index=0&id=08044d9a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__